import { connect } from 'react-redux';

import { actionGetHistoryCoin } from 'store/manageCoin/actions';

import HistoryCoin from './HistoryCoin';

const mapStateToProps = (state) => ({
  historyCoinList: state.ManageCoin.historyCoinList,
  historyCoinTotal: state.ManageCoin.historyCoinTotal,
  isLoadingGetHistoryCoin: state.ManageCoin.isLoadingGetHistoryCoin,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetHistoryCoin: (payload) => dispatch(actionGetHistoryCoin(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HistoryCoin);
